import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, ArrowUpRight } from "lucide-react";

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="bg-black text-white mt-24"
        >
            <div className="container-edge py-20 lg:py-28">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
                    <div className="lg:col-span-5">
                        <p className="overline text-white/60">ai4faculty.info</p>
                        <h2 className="mt-4 font-heading font-black text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[0.95]">
                            AI fluency for<br />the people who<br />
                            <span className="text-klein bg-white px-2">teach the world.</span>
                        </h2>
                    </div>

                    <div className="lg:col-span-3 lg:col-start-7">
                        <p className="overline text-white/60">Reach us</p>
                        <ul className="mt-4 space-y-3">
                            <li>
                                <a
                                    href="tel:8135281102"
                                    data-testid="footer-phone"
                                    className="flex items-center gap-2 text-lg hover:text-klein transition-colors"
                                >
                                    <Phone size={16} /> 813-528-1102
                                </a>
                            </li>
                            <li>
                                <a
                                    href="mailto:gdobson@degreesofsuccessinfo.com"
                                    data-testid="footer-email"
                                    className="flex items-start gap-2 text-base hover:text-klein transition-colors break-all"
                                >
                                    <Mail size={16} className="mt-1 shrink-0" /> gdobson@degreesofsuccessinfo.com
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div className="lg:col-span-2">
                        <p className="overline text-white/60">Site</p>
                        <ul className="mt-4 space-y-3 text-sm">
                            <li><Link to="/courses" className="hover:text-klein">Courses</Link></li>
                            <li><Link to="/workshops" className="hover:text-klein">Workshops</Link></li>
                            <li><Link to="/about" className="hover:text-klein">About</Link></li>
                            <li><Link to="/contact" className="hover:text-klein">Contact</Link></li>
                        </ul>
                    </div>
                </div>

                <div className="mt-16 pt-8 border-t border-white/15 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                    <p className="text-xs text-white/50">© {new Date().getFullYear()} ai4faculty. Built for educators.</p>
                    <Link to="/workshops" className="text-sm font-semibold inline-flex items-center gap-1 hover:text-klein">
                        Book a campus workshop <ArrowUpRight size={16} />
                    </Link>
                </div>
            </div>
        </footer>
    );
}
